<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <div :class="$style.content">

            <el-row style="margin-bottom: 10px"  v-show="activeShiftList.length > 0">
                <el-col :span="24"><span>启用的班次</span></el-col>
            </el-row>

            <el-row>
                <el-col :span="24"><BoxItem :info="item" :store_id="store_id"
                                            @increment="increment()"
                                            :class="$style.item" v-for="item in activeShiftList"
                                            :options="options" :key="item.mobile"/>
                </el-col>
            </el-row>

            <el-row style="margin-bottom: 10px" v-show="inactiveShiftList.length > 0">
                <el-col :span="24"><span>停用的班次</span></el-col>
            </el-row>
            <el-row>
                <el-col :span="24"><BoxItem :info="item" :store_id="store_id"
                                            @increment="increment()"
                                            :class="$style.item" v-for="item in inactiveShiftList"
                                            :options="options" :key="item.mobile"/>
                </el-col>
            </el-row>


        </div>

    </div>
</template>

<script>
    import BoxItem from './item.vue'
    import http from '../../../APIService/http'
    import {bus} from '../../../router/index.js'

    export default {
        data() {
            return {
                loading: false,
                store_id: '',
                activeShiftList: [],
                inactiveShiftList: [],
                shiftList: [],
                options: [],
            }
        },
        created() {

            let obj = this.$store.getters.getStore
            this.store_id = obj.id
            if (this.store_id) {
                this.initInfo()
            }
        },
        components: {
            BoxItem
        },
        computed: {

        },
        methods: {
            increment() {

                this.initInfo()
            },
            async initInfo() {
                try {

                    this.loading = true

                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id,
                        store_id:this.store_id
                    }

                    await http.post('/wapi/v1/getSettingShiftList', data).then(res => {

                        this.activeShiftList = []
                        this.inactiveShiftList = []
                        res.data.forEach(item => {
                            if(item.status === 'ACTIVE'){
                              this.activeShiftList.push(item)
                            }else {
                               this.inactiveShiftList.push(item)
                            }
                        })



                        this.loading = false
                    })

                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
        }
    }
</script>
<style lang="scss" module>
    .container {
        .content {
            /*border-bottom: 2px dotted #e7eaec;*/
            &:after {
                display: block;
                overflow: hidden;
                content: ' ';
                clear: both;
            }
            padding: 20px 10px;
            .item {
                float: left;
                margin-right: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/stores/attendance/index.vue